<template>
  <v-tooltip
    :top="!bottom"
    :bottom="bottom"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        large
        :loading="loading"
        :disabled="disabled"
        v-on="on"
        @click="download"
      >
        <v-icon>get_app</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }} </span>
  </v-tooltip>
</template>

<script>
import * as downloadFileApi from "@/backend/downloadFileApi.js";

export default {
  props: ["location", "params", "tooltip", "filename", "extension", "bottom", "disabled"],
  data: () => ({
    loading: false,
  }),
  computed: {
    fullName() {
      const fullName = this.filename || "file";
      return this.extension ? `${fullName}.${this.extension}` : fullName;
    },
  },
  methods: {
    download() {
      this.loading = true;
      downloadFileApi
        .download(this.location, this.params)
        .then(url => {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.fullName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
  },
};
</script>
